import React, { Component } from 'react';
import { Button, Container, Form, FormGroup, Input, Label } from 'reactstrap';

import FormJobPageButtons
    from "../../components/portfolio/FormJobPage/FormJobPageButtons";
import { FormattedMessage, injectIntl } from "react-intl";
import FormJobPagePredilectionInput
    from "../../components/portfolio/FormJobPage/FormJobPagePredilectionInput";
import { toast } from "react-toastify";
import SalaryInput from "../../components/form/SalaryInput";
import { formatPhone } from '../../helpers/format'
import MetaTags from '../../components/SEO/MetaTags'
import { handleRequestError, Request } from '../../helpers/request'
import { businessUnitOptions } from '../../helpers/select'
import LocalisationSelect from '../../components/form/LocalisationSelect'
import LocaleLink, { addLocalePrefix } from '../../components/Routes/LocaleLink'
import Faq from "../../components/Faq/Faq";
import {faqCardsHeader, faqCardsBody} from "../../components/Faq/Pages/OpenApplicationPage";


class FormOpenApplicationPage extends Component
{
    state = {
        business_unit: null,
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        exp: '',
        tech: '',
        salary: '',
        employment_preference: '',
        city: '',
        file: null,
        linkedin: '',
        conditions_accepted: false,
        loading: false,
        winScroll: 0
    };

    startStickyPosition = '280'
    blockStopStickyPosition = '870'
    stopStickyPosition = '1660'

    componentDidMount() {
        window.addEventListener('scroll', this.listenToScroll)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.listenToScroll)
    }

    listenToScroll = () => {
        const winScroll = document.body.scrollTop || document.documentElement.scrollTop

        this.setState({
            winScroll: winScroll,
        })
    }

    isSticky = () => {
        return (
            document.body.offsetWidth > 768
            && (this.state.winScroll > this.startStickyPosition && this.state.winScroll < this.stopStickyPosition)
        )
    }

    getTopStickyPosition = () => {
        if (this.state.winScroll > this.blockStopStickyPosition) {
            return ((this.blockStopStickyPosition - this.startStickyPosition)/10) + 'rem'
        }

        return ((this.state.winScroll - this.startStickyPosition)/10) + 'rem'
    }

    submit(e) {
        e.preventDefault();

        const { intl } = this.props;

        const {
            business_unit,
            firstname,
            lastname,
            phone,
            email,
            exp,
            tech,
            salary,
            employment_preference,
            file,
            linkedin,
            city,
        } = this.state;

        if (!file) {
            return toast.error(
                intl.formatMessage({
                    id: "portfolio.form_job.toast.file_missing",
                    defaultMessage: "Veuillez importer votre CV."
                })
            )
        }

        this.setState({ loading: true });

        let body = {
            business_unit,
            firstname,
            lastname,
            phone,
            email,
            exp,
            tech,
            salary,
            employment_preference,
            city,
            linkedin,
            region: null
        };

        if (file) {
            body.file = file;
        }

        Request.post('open-application/submit', body)
            .then((data) => {
                toast.success(
                    intl.formatMessage({
                        id: "portfolio.form_job.application_sent",
                        defaultMessage: "Votre message a bien été envoyé."
                    })
                );

                this.props.history.push({
                    pathname: addLocalePrefix('/candidature-suite'),
                    candidate_id: data.id
                });
            })
            .catch((e) => {
                handleRequestError(e);
                this.setState({ loading: false });
            });
    }

    toggleConditionsAccepted() {
        this.setState({ conditions_accepted: !this.state.conditions_accepted });
    }

    render() {
        const { intl } = this.props;

        return (
            <div className="form-open-application-page">

                <MetaTags page="application" />

                <section className="candidate-form">
                    <Container>
                        <div className="form-head">
                            <h1 className="line-heading">
                                <FormattedMessage
                                    id="portfolio.form_open_application.title"
                                    defaultMessage="PAS LE TEMPS DE CHERCHER UN JOB&nbsp;?"
                                />
                            </h1>
                            <h2 className="subtitle">
                                <FormattedMessage
                                    id="portfolio.form_open_application.subtitle"
                                    defaultMessage="On trouve pour vous ! Envoyez-nous votre candidature spontanée."
                                />
                            </h2>
                        </div>
                        <div className="candidate-form-wrap">
                            <Form onSubmit={(e) => this.submit(e)} className="candidate-form-wrap-form">
                                <div className="fields-row">
                                    <FormGroup className="form-group-half">
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_open_application.firstname.label"
                                                defaultMessage="Prénom*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="text"
                                            className="input-field"
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_open_application.firstname.placeholder",
                                                    defaultMessage: "Pierre"
                                                })
                                            }
                                            value={this.state.firstname}
                                            onChange={(e) => this.setState({ firstname: e.target.value })}
                                        />
                                    </FormGroup>
                                    <FormGroup className="form-group-half">
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_open_application.lastname.label"
                                                defaultMessage="Nom*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="text"
                                            className="input-field"
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_open_application.lastname.placeholder",
                                                    defaultMessage: "Durand"
                                                })
                                            }
                                            value={this.state.lastname}
                                            onChange={(e) => this.setState({ lastname: e.target.value })}
                                        />
                                    </FormGroup>
                                </div>
                                <div className="fields-row">
                                    <FormGroup className="form-group-half">
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_open_application.phone.label"
                                                defaultMessage="Téléphone*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="tel"
                                            pattern="([+]?[0-9]+)?"
                                            className="input-field"
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_open_application.phone.placeholder",
                                                    defaultMessage: "Format : (+33)0123456789"
                                                })
                                            }
                                            value={this.state.phone}
                                            onChange={(e) => this.setState({phone: formatPhone(e)})}
                                        />
                                    </FormGroup>
                                    <FormGroup className="form-group-half">
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_open_application.email.label"
                                                defaultMessage="Email*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="email"
                                            className="input-field"
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_open_application.email.placeholder",
                                                    defaultMessage: "Pour vous écrire"
                                                })
                                            }
                                            value={this.state.email}
                                            onChange={(e) => this.setState({ email: e.target.value })}
                                        />
                                    </FormGroup>
                                </div>
                                <div className="fields-row">
                                    <FormGroup className="form-group-full">
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_open_application.linkedin.label"
                                                defaultMessage="Profil LinkedIn*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="url"
                                            className="input-field"
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_open_application.linkedin.placeholder",
                                                    defaultMessage: "https://www.linkedin.com/in/votre-profil"
                                                })
                                            }
                                            pattern="https://.*"
                                            value={this.state.linkedin}
                                            onChange={(e) => this.setState({ linkedin: e.target.value })}
                                        />
                                    </FormGroup>
                                </div>

                                <div className="fields-row">
                                    <FormGroup className="form-group-half">
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_open_application.years_exp.label"
                                                defaultMessage="Années d'expérience*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="number"
                                            className="input-field"
                                            min={0}
                                            placeholder={"2"}
                                            value={this.state.exp}
                                            onChange={(e) => this.setState({ exp: e.target.value })}
                                        />
                                    </FormGroup>
                                    <FormGroup className="form-group-half">
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_open_application.city.label"
                                                defaultMessage="Ville souhaitée*"
                                            />
                                        </Label>

                                        <LocalisationSelect
                                            value={this.state.city}
                                            onChange={city => this.setState({ city })}
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_open_application.city.placeholder",
                                                    defaultMessage: "Paris"
                                                })
                                            }
                                        />
                                    </FormGroup>
                                </div>
                                <div className="fields-row">
                                    <div className="check-list">
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_open_application.type.label"
                                                defaultMessage="Pour quel type de poste souhaitez-vous postuler ?"
                                            />
                                        </Label>
                                        <FormGroup>
                                            {this.renderRadio()}
                                        </FormGroup>
                                    </div>
                                </div>
                                <div className="brief-fields-row">
                                    <FormGroup className="form-group-half">
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_open_application.position.label"
                                                defaultMessage="Poste souhaité*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="text"
                                            className="input-field"
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_open_application.position.placeholder",
                                                    defaultMessage: "Indiquez l'intitulé du poste"
                                                })
                                            }
                                            value={this.state.employment_preference}
                                            onChange={(e) => this.setState({ employment_preference: e.target.value })}
                                        />
                                    </FormGroup>
                                    <FormGroup className="form-group-half">
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_open_application.salary.label"
                                                defaultMessage="Salaire souhaité*"
                                            />
                                        </Label>
                                        <SalaryInput
                                            required
                                            className="input-field"
                                            min={0}
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_open_application.salary.placeholder",
                                                    defaultMessage: "Salaire brut annuel"
                                                })
                                            }
                                            value={this.state.salary}
                                            onChange={(e) => this.setState({ salary: e.target.value })}
                                        />
                                    </FormGroup>
                                </div>
                                <div className="fields-row">
                                    <div className="form-group textarea-container form-group-full">
                                        <FormJobPagePredilectionInput
                                            business_unit={this.state.business_unit}
                                            required={true}
                                            value={this.state.tech}
                                            onChange={(e) => this.setState({ tech: e.target.value })}
                                        />
                                    </div>
                                </div>

                                <FormJobPageButtons
                                    onDrop={(file) => this.setState({ file })}
                                    onDataLoaded={(data) => this.setState({ ...data })}
                                    loading={(loading) => this.setState({ loading })}
                                />

                                <div className="btn-wrap checkbox-wrap">
                                    <div className="custom-control checkbox-wrap">
                                        <Input
                                            required
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="posibility"
                                            onChange={() => this.toggleConditionsAccepted()}
                                        />
                                        <Label className="custom-control-label" htmlFor="posibility">
                                            <span className="box-block mr-3"/>
                                            <span className="check-text">
                                            <FormattedMessage
                                                id="portfolio.form.cgu"
                                                defaultMessage="En cochant la case, vous confirmez avoir lu et accepté les conditions d'utilisation de vos données listées {link}."
                                                values={{
                                                    link: (
                                                        <LocaleLink to={'/cgu'} className={'link-cgu'} target='_blank'>
                                                            <FormattedMessage
                                                                id="myurban.header.notifications.new_application_to_job_order.here"
                                                                defaultMessage={'ici'}
                                                            />
                                                        </LocaleLink>
                                                    )
                                                }}/>
                                            </span>
                                        </Label>
                                    </div>
                                    <Button
                                        className="btn btn-danger"
                                        disabled={this.state.loading}
                                    >
                                        <FormattedMessage
                                            id="portfolio.form_open_application.button"
                                            defaultMessage="ENVOYER"
                                        />
                                    </Button>
                                </div>
                            </Form>
                            <div className="candidate-form-wrap-right" style={{position: 'relative'}}>
                                <div className="candidate-form-wrap-right-content" style={
                                    (this.isSticky())
                                    ? {
                                        top: this.getTopStickyPosition(),
                                        position: 'absolute'
                                    }
                                    : {}
                                }>
                                    <div className="bloc-text" >
                                        <p>
                                            <FormattedMessage
                                                id="portfolio.form_open_application.bloc_1.paragraph_1"
                                                defaultMessage="Chez Urban Linker, nos headhunters sont de grands passionnés du secteur digital et de ses métiers. Nous bénéficions d’une expertise dans plusieurs domaines : tech, product, sales & marketing et design. Vous avez accès à nos nombreuses annonces et offres d’emploi, mais vous pouvez également demander un accompagnement personnalisé."
                                            />
                                        </p>
                                        <p>
                                            <FormattedMessage
                                                id="portfolio.form_open_application.bloc_1.paragraph_2"
                                                defaultMessage="Vous avez un profil digital et manquez de temps pour trouver du travail ? Pas encore trouvé le job de vos rêves ? Envoyez-nous votre CV et précisez vos envies. Notre cabinet de recrutement s’occupe ensuite de dénicher l’opportunité qui correspond à vos besoins."
                                            />
                                        </p>
                                        <p>
                                            <FormattedMessage
                                                id="portfolio.form_open_application.bloc_1.paragraph_3"
                                                defaultMessage="Remplissez ce formulaire pour que nous puissions en savoir davantage sur votre parcours professionnel, vos envies, vos compétences, vos références. Tout ce qui peut nous permettre d’élaborer un dossier de candidature complet. Nos chasseurs de talents pourront par la suite vous proposer des offres d’emploi matchant avec votre profil."
                                            />
                                        </p>
                                        <p>
                                            <FormattedMessage
                                                id="portfolio.form_open_application.bloc_1.paragraph_4"
                                                defaultMessage="Le plus d’Urban Linker ? Grâce à notre plateforme digitale, votre projet de recherche d’emploi prend vie !"
                                            />
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Container>
                    <Container>
                        <div className="faq open-application-faq">
                            <div className="container">
                                <div className="faq-header open-application-faq-header">
                                    <h2 className="page-header">
                                        <FormattedMessage
                                            id="faq.open_application.title"
                                            defaultMessage="Nous répondons à vos questions" />
                                    </h2>
                                    <p>
                                        <FormattedMessage
                                            id="faq.open_application.subtitle"
                                            defaultMessage="Quels sont les types de postes qu'Urban Linker peut me proposer ? Quelles sont les étapes d'un processus de recrutement avec Urban Linker ? Quels sont les types d'entreprises qu'on peut voir sur le site ?"
                                        />
                                    </p>
                                </div>
                                <Faq
                                    cardsBody={faqCardsBody}
                                    cardsHeader={faqCardsHeader}
                                    cardsLength="5"
                                />
                            </div>
                        </div>
                    </Container>
                </section>
            </div>
        )
    }

    renderRadio = () => {
        return businessUnitOptions.map((option, key) => {
            return (
                <FormGroup check key={key}>
                    <Label className="checkbox-warning-round">
                        <Input required onChange={e => this.setState({ business_unit: e.target.value })} type="radio" name="radio-btn" value={option.value}/>
                        <span>{option.label}</span>
                    </Label>
                </FormGroup>
            )
        })
    }
}

export default injectIntl(FormOpenApplicationPage);
